import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import FileSystemExample from '~/examples/file-system';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "a-unified-way-to-work-with-all-kinds-of-documents"
    }}>{`A `}<a parentName="h2" {...{
        "href": "https://unifiedjs.com"
      }}>{`unified`}</a>{` way to work with all kinds of documents`}</h2>
    <p>{`Render, search, mark, annotate, highlight, convert, and save any document with a simple unified API.`}</p>
    <FileSystemExample mdxType="FileSystemExample" />
    {
      /* Definitions */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      